import Vue from 'vue'
import App from './App.vue'
import VueRouter from './router'
import vuetify from './plugins/vuetify'
import VueLoading from 'vuejs-loading-plugin'
//import VueCookies from 'vue-cookies'
import store from './plugins/store.js'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VueMask from 'v-mask'
//import vueNumeralFilterInstaller from 'vue-numeral-filter';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

//import './assets/css/bpc-global.css'

Vue.config.productionTip = false

Vue.use(VueMask);
Vue.use(VueLoading)
//Vue.use(VueCookies)
//Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
Vue.use(vue2Dropzone)

new Vue({
  vuetify,
  router: VueRouter,
  store,
  render: h => h(App)
}).$mount('#app')
